import { apiBase } from './api-base'

export type RenameFundManagerRequest = {
  managementCompanyCode: string
  newName: string
}

export type RenameFundManagerResult = {
  assetIds: string[]
  count: number
}

const assetFundManagerApi = apiBase.injectEndpoints({
  endpoints: build => ({
    renameFundManager: build.mutation<
      RenameFundManagerResult,
      { body: RenameFundManagerRequest; tenant: string }
    >({
      query: ({ body, tenant }) => ({
        url: `/${tenant}/asset/fund-manager`,
        method: 'PUT',
        body
      })
    })
  })
})

export const { useRenameFundManagerMutation } = assetFundManagerApi
